module.exports = __webpack_public_path__ + "img/journey-03.6e5e8d98.png";